import { cn } from '@/shared/lib/utils'

/**
 * Computes the header className for ResponsiveModal based on viewport and sticky state.
 * Mobile Drawer never uses sticky behaviour — vaul Drawer scrolls the body, not the header.
 */
export function useModalSticky({
  stickyHeader,
  isP0,
  isDesktop,
}: {
  stickyHeader: boolean
  isP0: boolean
  isDesktop: boolean
}): string {
  if (!isDesktop) {
    // Mobile Drawer header — no sticky behaviour
    // Prepend p-0 to neutralise DrawerHeader's base p-4 before applying px-2 py-1.
    // Without this, both p-4 and px-2 py-1 exist in the DOM; visual winner depends
    // on Tailwind stylesheet ordering, which is not guaranteed across builds.
    return cn('pr-12 text-left', isP0 && 'p-0 px-2 py-1')
  }
  if (stickyHeader) {
    return cn(
      'text-left sticky top-0 z-10 bg-white dark:bg-slate-900',
      'border-b border-slate-100 dark:border-slate-800 pb-3',
      isP0 ? 'pl-6 pr-12 pt-6' : '-mx-6 -mt-6 pl-6 pr-12 pt-6',
    )
  }
  return cn('text-left pr-12', isP0 ? 'pl-6 pt-6 pb-0' : 'pb-2')
}
